import React from "react";
import Header from "../../Component/Header/Header";
import Sidebar from "../../Component/Sidebar/Sidebar";
import AcceptDeleteOrdersComponent from "../../Component/AcceptDeleteOrdersComponent/AcceptDeleteOrdersComponent";

function AcceptDeteleOrders() {
  return  <AcceptDeleteOrdersComponent />
     
}

export default AcceptDeteleOrders;
